import request from '@/utils/request'

export function login(params) {
  return request({
    url: '/v2/login/login',
    method: 'post',
    data: params
  })
}

export function getInfo(params) {
  return request({
    url: '/user/info',
    method: 'get',
    params: params
  })
}

export function logout() {
  return request({
    url: '/user/logout',
    method: 'get'
  })
}

export function findUserId(param) {
  return request({
    url: '/v2/finduserinfo/findUserId',
    method: 'post',
    data: param
  })
}

export function changeTempPassword(param) {
  return request({
    url: '/v2/finduserinfo/changeTempPassword',
    method: 'post',
    data: param
  })
}

export function isEntryAdmin() {
  return request({
    url: '/v2/sec/orgUsers/isEntryAdmin',
    method: 'post'
  })
}

export function getUserInfo(param) {
  return request({
    url: '/v2/sec/userinfo/getUserInfo',
    method: 'post',
    data: param
  })
}

export function getUserEmailInfo(param) {
  return request({
    url: '/v2/sec/userinfo/getUserEmailInfo',
    method: 'post',
    data: param
  })
}

export function modifyUserInfo(param) {
  return request({
    url: '/v2/sec/userinfo/modifyUserInfo',
    method: 'post',
    data: param
  })
}

export function getMangerInfo(params) {
  return request({
    url: '/v2/sec/orgConfig/getMangerInfo',
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=utf-8'
    }
  })
}

export function removeUserInfo(params) {
  return request({
    url: '/v2/sec/userinfo/removeUserInfo',
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=utf-8'
    },
    data: params
  })
}

export function getIsAdmin () {
  return request({
    url: '/v2/sec/orgUsers/isAdmin',
    method: 'post'
  })
}

export function isTerminateMemberCheck (params) {
  return request({
    url: '/v2/user/isTerminateMemberCheck',
    method: 'post',
    data: params
  })
}

export function internalContract(params) {
  return request({
    url: '/v2/internalContract',
    method: 'post',
    data: params
  })
}

